<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'actions.forgot_password' | translate }}
    v-card-content
      v-text-field.mb-3(
        :label="$t('base.email')"
        v-model="form.email")
      p {{ 'actions.forgot_password_desc' | translate }}
    v-card-actions
      v-btn.mr-2(
        :loading="loading"
        @click="send") {{ 'actions.send' | translate }}
</template>

<script>
import api from '@/api'

export default {
  name: 'ForgotPassword',

  mounted () { },
  data: () => ({
    form: {
      email: null
    },
    loading: false
  }),

  methods: {
    send () {
      this.loading = true
      api.auth.forgotPassword(this.form)
        .then(response => {
          this.loading = false
          if (!response.error) {
            this.$emit('close')
          }
          this.$toasted.show(response.data.error, {
            position: 'bottom-center',
            duration: 5000
          })
          for (const key in response.data.errors) {
            this.$toasted.show(response.data.errors[key], {
              position: 'bottom-center',
              duration: 5000
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
